module.exports = __webpack_public_path__ + "static/media/icono-botones@3x.30d7b078.png";